import { createContext, useContext } from "react";
import { useAppContext } from "./AppContext";
import { useFetch } from "../hooks/useFetch";
import { get_xflow_partners } from "../constants/apis";
import { XflowPartnerRes } from "../types/XFlow";

type Partner = {
  data: XflowPartnerRes[] | null;
  loading: boolean;
  refetch: () => void;
};

const XFlowPartnerContext = createContext<Partner | null>(null);

export const XFlowPartnerContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { jwtToken } = useAppContext();

  const { data, loading, refetch } = useFetch<XflowPartnerRes[]>(
    get_xflow_partners,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        Content_Type: "application/json",
      },
    },
    jwtToken!
  );

  return (
    <XFlowPartnerContext.Provider value={{ data, loading, refetch }}>
      {children}
    </XFlowPartnerContext.Provider>
  );
};

export const useXFlowPartnerContext = () => {
  const context = useContext(XFlowPartnerContext);

  if (!context) throw new Error("Context must be used within an provider");

  return context;
};
